import React, { useState, useEffect } from 'react';
import { subscribeExternalDrag } from '../../store/externalDragStore';
import './index.css';

const DragGhost = () => {
    const [dragState, setDragState] = useState({ isDragging: false, item: null, x: 0, y: 0 });

    useEffect(() => {
        return subscribeExternalDrag(setDragState);
    }, []);

    if (!dragState.isDragging || !dragState.item) return null;

    return (
        <div
            className="drag-ghost"
            style={{ left: dragState.x, top: dragState.y }}
        >
            {dragState.item.title}
        </div>
    );
};

export default DragGhost;
